import { convertRowsToData } from '../utils/dataUtils'

export default function ScatterDataController(rows) {
  let headers = rows[0]
  let propperHeaders = ['id', 'label', 'year', 'x', 'y', 'size', 'dates']
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 4)
  const refYear = data.reduce((acum, row) => {
    return Math.max(acum, ...row.value.find(d => d.id === 'dates').value)
  }, 0)

  return data.map(datum => {
    let point = {
      id: datum.id,
      year: datum.year,
      label: datum.label,
      x: +datum.value.find(d => d.id === 'x').value,
      y: +datum.value.find(d => d.id === 'y').value,
      size: +datum.value.find(d => d.id === 'size').value,
      dates: datum.value.find(d => d.id === 'dates').value,
    }

    point.group = Object.values(point.dates).reduce(
      (itIs, value) => itIs || value.getTime() !== refYear,
      false
    )
      ? 'Less-recent time period'
      : 'Current time period'
    return point
  })
}
